import React, { useCallback } from 'react'
import { get } from 'lodash'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { getLinksFromCookie } from '../utils/common'
import { A, Button } from '@rebrandly/styleguide'

import config from '../config'

const SignUpButton = ({ children, isQr, ...rest }) => {
  const flags = useFlags()

  const handleSignUp = useCallback(() => {
    const { redirectToSignUp } = require('../utils/auth')

    const validLinks = getLinksFromCookie(isQr)

    const plan = get(flags, 'plans.free.id', config.plans.find(p => p.name === 'free').id)

    const redirectUrl = validLinks?.length
      ? redirectToSignUp({ plan, links: validLinks.map(link => ({id: link.id})) })
      : redirectToSignUp({ plan })

    window.open(redirectUrl, '_blank')
  }, [flags, isQr])

  return (
    <>
      {children ? (
        <A onClick={handleSignUp} target="_blank" rel="noopener noreferrer" {...rest}>
          {children}
        </A>
      ) : (
        <Button onClick={handleSignUp} {...rest} />
      )}
    </>
  )
}

export default SignUpButton
